import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface DialogConfirmActionData {
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
}

@Component({
  selector: 'app-dialog-confirm-action',
  templateUrl: './dialog-confirm-action.component.html',
  styleUrl: './dialog-confirm-action.component.scss',
  standalone: false,
})
export class DialogConfirmActionComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public readonly data: DialogConfirmActionData,
    public readonly dialogRef: MatDialogRef<DialogConfirmActionComponent, boolean>,
  ) {}
}
